import type { OnInit, OnDestroy } from '@angular/core';
import { Component, Input, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { environment } from '../../../enviroment/enviroment';
import type { Car } from '../../models/car';
import type { LocationDetail } from '../../models/location-detail';
import { SharedModule } from '../../shared/shared.module';
import { WebFacade } from '../../store/web/web-facade.service';

@Component({
  selector: 'app-car-card',
  imports: [SharedModule],
  templateUrl: './car-card.component.html',
  styleUrls: ['./car-card.component.scss'],
})
export class CarCardComponent implements OnInit, OnDestroy {
  router = inject(Router);
  webfacadeService = inject(WebFacade);
  dialog = inject(MatDialog);

  @Input() car!: Car;
  @Input() hasPriceDetail = true;
  @Input() hasButton = true;
  @Input() height = 540;

  currentImageIndex = 0;
  private autoSlideInterval: ReturnType<typeof setTimeout> | null = null;
  private readonly slideDelay = 3000;
  avatar: string = environment.ANGULAR_DEFAULT_PLACEHOLDER;
  locationDetail!: LocationDetail;
  selectedSubscription: 'per_minute' | 'hourly' | 'daily' | 'per_week' | 'per_month' = 'per_minute';
  selectedPrice: string | null = null;

  ngOnInit(): void {
    // this.startAutoSlide();

    this.webfacadeService.locationDetail$.subscribe((l: LocationDetail) => {
      if (l.pickupDate) {
        this.locationDetail = l;
      }
    });

    this.setDefaultSubscriptionAndPrice();
  }

  ngOnDestroy(): void {
    this.clearAutoSlide();
  }

  setDefaultSubscriptionAndPrice(): void {
    if (this.car.dailyRate && +this.car.dailyRate > 0) {
      this.selectedSubscription = 'daily';
      this.selectedPrice = this.car.dailyRate;
      return;
    }

    const PRICE_ORDER = [
      { key: 'per_minute', value: this.car.perMinuteRate },
      { key: 'hourly', value: this.car.hourlyRate },
      { key: 'daily', value: this.car.dailyRate },
      { key: 'per_week', value: this.car.weeklyRate },
      { key: 'per_month', value: this.car.monthlyRate },
    ];

    const FIRST_AVAILABLE = PRICE_ORDER.find((p) => p.value);

    if (FIRST_AVAILABLE) {
      this.selectedSubscription = FIRST_AVAILABLE.key as
        | 'per_minute'
        | 'hourly'
        | 'daily'
        | 'per_week'
        | 'per_month';
      this.selectedPrice = FIRST_AVAILABLE.value;
    } else {
      this.selectedPrice = null;
    }
  }

  // private startAutoSlide() {
  //   this.clearAutoSlide();
  //   if (this.images.length > 1) {
  //     this.autoSlideInterval = setInterval(() => {
  //       this.nextImage(false);
  //     }, this.slideDelay);
  //   }
  // }

  private clearAutoSlide(): void {
    if (this.autoSlideInterval) {
      clearInterval(this.autoSlideInterval);
      this.autoSlideInterval = null;
    }
  }

  get images(): string[] {
    return Array.isArray(this.car?.carImages) ? this.car.carImages : [];
    // if (Array.isArray(IMAGES) && IMAGES.length > 0) {
    // const validImgs = imgs
    //   .filter((img: any) => typeof img?.document_path === 'string')
    //   .map((img: any) => this.buildImageUrl(img.document_path));
    // Return only the first image as an array
    // return validImgs.length ? [validImgs[0]] : [];
    // }
  }

  prevImage(userInitiated = true): void {
    if (this.images.length > 0) {
      this.currentImageIndex =
        (this.currentImageIndex - 1 + this.images.length) % this.images.length;
      if (userInitiated) {
        this.restartAutoSlide();
      }
    }
  }

  nextImage(userInitiated = true): void {
    if (this.images.length > 0) {
      this.currentImageIndex = (this.currentImageIndex + 1) % this.images.length;
      if (userInitiated) {
        this.restartAutoSlide();
      }
    }
  }

  selectImage(index: number): void {
    this.currentImageIndex = index;
    this.restartAutoSlide();
  }

  private restartAutoSlide(): void {
    this.clearAutoSlide();
    // this.startAutoSlide();
  }

  getDiscountedPrice(price: number): number {
    if (this.car.hotDeal) {
      const VALID_PRICE = price ?? 0;
      const DISCOUNT = VALID_PRICE * 0.1;
      return VALID_PRICE - DISCOUNT;
    } else {
      return price;
    }
  }
}
